export default "__VITE_ASSET__DMRXwS7J__"